import type { OperationsNode } from '../types/operations.types'
import { isTeamNode } from './nodeTypes'

const collectTeamIds = (node: OperationsNode, into: Set<string>): void => {
  if (isTeamNode(node)) {
    into.add(node.teamId)
    return
  }
  node.children.forEach((child) => collectTeamIds(child, into))
}

/**
 * Distinct teams under a node, walking through conferences and divisions alike
 * — the Teams figure for a panel whose own children are competitions rather
 * than teams.
 *
 * Distinct by `teamId`, not by node: the same team placed in two divisions is
 * two tree nodes but one team. A team node has no teams under it, so it is 0.
 */
export const teamCountForNode = (node: OperationsNode): number => {
  if (isTeamNode(node)) {
    return 0
  }
  const teamIds = new Set<string>()
  collectTeamIds(node, teamIds)
  return teamIds.size
}
